import { CommonFrontOfficeCrumbs } from './breadcrumb';

export const ClaimsCrumbs = [
  ...CommonFrontOfficeCrumbs,
  {
    name: 'Attestazione',
    path: '/sportello/attestazione',
  },
];
